var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-flex",attrs:{"id":"app"}},[(_vm.canRenderContainer)?_c('ContainerWithNav',[(_vm.hasStartupLoadError)?_c('StartupLoadError'):(_vm.isInfoStored)?_c('router-view'):_vm._e()],1):_vm._e(),_c('InactiveNotice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }